function getImagePaths(directory) {
	const images = [];
	directory.keys().map((item) => images.push(item.replace('./', '')));
	return images;
}

const directory = require.context('./', false, /\.(png|jpe?g|svg)$/);
const images = getImagePaths(directory);
export { images };
